import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environment';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';
import { getTokenParams } from '@shared/utils/get-token-params';
import * as Sentry from '@sentry/angular';
import { isStorePreview } from '@app/features/wheel-store/store-preview';
import { isEngineWheel } from '@app/features/engine/engine-route';

const { token, instance, gameUuid, language: urlLang } = getTokenParams();

if (isEngineWheel()) {
  bootstrapApplication(AppComponent, appConfig).catch(console.error);
} else if (isStorePreview()) {
  import('@app/features/wheel-store/preview.fixture').then(
    ({ previewUser }) => {
      (window as WindowWithUser).user = previewUser;
      bootstrapApplication(AppComponent, appConfig).catch(console.error);
    },
  );
} else if (token) {
  const selectedLanguage = urlLang || decodeTokenLang(token) || 'en';

  fetch(`${environment.backendUrl}/api/public/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': selectedLanguage,
    },
    body: JSON.stringify({
      token,
      instance,
      gameUuid,
      language: selectedLanguage,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      Sentry.init({
        dsn: 'https://4725250d0f5c43d63337a6077bb24ed5@o4511632967401472.ingest.de.sentry.io/4511660856180816',
        environment: environment.name,
        integrations: [Sentry.replayIntegration()],
        replaysOnErrorSampleRate: 1.0,
      });

      (window as WindowWithUser).user = data;
      bootstrapApplication(AppComponent, appConfig).catch((err) =>
        console.error(err),
      );
    })
    .catch((error) => console.error('Authentication error:', error));
} else {
  console.warn('No token!');
}

function decodeTokenLang(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.language ?? null;
  } catch (err) {
    console.warn('Failed to decode JWT', err);
    return null;
  }
}
